import type ToolTrackingRecordVM from 'ab-viewModels/toolTrackingRecord/table.viewModel';

import { ToolStateLabel } from '@acceligentllc/shared/enums/toolState';
import { ToolStatusLabel } from '@acceligentllc/shared/enums/toolStatus';

const CSV_HEADER_EQUIPMENT_KEYS = [
	'Status',
	'Repair status',
	'Status Valid',
	'Location Type',
	'Equipment/Office/Other',
	'Tracking Number',
	'Reason For Transfer',
];

export const toCSVData = (viewModels: ToolTrackingRecordVM[]): string[][] => {
	const header: string[] = [...CSV_HEADER_EQUIPMENT_KEYS];

	const data: string[][] = viewModels
		.map((record) => {
			return [
				ToolStateLabel[record.state],
				ToolStatusLabel[record.status],
				`from ${record.validFrom} to ${record.validTo}`,
				record.locationId ? 'Office' : record.equipmentId ? 'Equipment' : record.toolRepairId ? 'Repair' : 'Other',
				record.locationName,
				record.trackingNumber ?? 'N/A',
				record.reason ?? 'N/A',
			];
		});
	return [header, ...data];
};
